import { render, staticRenderFns } from "./ShipmentsHelpTab.vue?vue&type=template&id=99fa018c&"
import script from "./ShipmentsHelpTab.vue?vue&type=script&lang=js&"
export * from "./ShipmentsHelpTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports